//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.Electrical.js";
import "../no/NXObject.js";
import "../no/ugmath.js";
let d=[[],[[[],"CondemnLayoutViewEntities",{},0,0],[[],"UncondemnLayoutViewEntities",{},0,0],[["orientation","origin"],"PositionLayoutView",{},2,0],[["toOrientation"],"PositionLayoutView1",{},1,0],[[],"FlipView",{},0,0],[[],"GetViewDirection",{R_:{viewDirection:''}},0,0],[[],"HighlightView",{},0,0],[[],"UnhighlightView",{},0,0],[["orientation","origin"],"GetViewMatrixAndOrigin",{},0,0]],[]];
SPLM.Routing.Electrical.CablewaysLayoutView = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.Electrical.CablewaysLayoutView";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;